(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        // AMD is used - Register as an anonymous module.
        define(['jquery', 'moment'], factory);
    } else if (typeof exports === 'object') {
        factory(require('jquery'), require('moment'));
    } else {
        // Neither AMD nor CommonJS used. Use global variables.
        if (typeof jQuery === 'undefined') {
            throw 'bq/plugins/momen.js requires jQuery to be loaded first';
        }
        if (typeof moment === 'undefined') {
            throw 'bq/plugins/momen.js requires Moment.js to be loaded first';
        }
        factory(jQuery, moment);
    }
}(function ($, moment) {
    'use strict';

    if (!moment) {
        throw new Error('snippets/moment.js requires Moment.js to be loaded first');
    }

    $.extend(moment, {
        createFromInputFallback: function(config) {
            configFromString(config);
        }
    });


    var configFromString = function(config) {
        if (typeof config._locale._longDateFormat.L != 'undefined') {
            var parsedDate = getDateByFormat(config._i, config._locale._longDateFormat.L);
            if (moment.isDate(parsedDate)) {
                config._d = parsedDate;
                config._isValid = true;
            }
        }
    },

    getDateByFormat = function(date, format) {
        var dateRegex = /(\d{2,4})\/(\d{2,4})\/(\d{2,4})/i,
            dateMatch = dateRegex.exec(date),
            formatRegex = /(\w{2,4})\/(\w{2,4})\/(\w{2,4})/i,
            formatMatch = formatRegex.exec(format);
        if (!dateMatch || !formatMatch) {
            return null;
        }

        var dayIdx = formatMatch.indexOf('DD'),
            monthIdx = formatMatch.indexOf('MM'),
            yearIdx = formatMatch.indexOf('YYYY');

        if (!dayIdx || !monthIdx || !yearIdx) {
            return null;
        }

        return new Date(dateMatch[yearIdx]+'-'+dateMatch[monthIdx]+'-'+dateMatch[dayIdx]);
    },

    _moment = moment.utils_hooks__hooks;

    return _moment;
}))